
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ElementPositionOnCanvas,
  calculateDomElementPositionOnCanvas,
  listenForDomElementPositionChanges,
  getWrapperStyle,
  getOutlineStyle
} from "@/futurelayer/canvas/canvas-controls/element-positioning";

@Component({})
export default class FutureLayerGalleryImageOutline extends Vue {
  @Prop()
  htmlElement!: HTMLElement;

  elementPositionOnCanvas: ElementPositionOnCanvas = false;
  cleanupListeners: () => void = () => {};

  mounted() {
    this.elementPositionOnCanvas = calculateDomElementPositionOnCanvas(this.htmlElement);

    this.cleanupListeners = listenForDomElementPositionChanges(
      this.htmlElement,
      (newPosition: ElementPositionOnCanvas) => {
        this.elementPositionOnCanvas = newPosition;
      }
    );
  }

  beforeDestroy() {
    this.cleanupListeners();
  }

  get cssStyleForWrapper(): Record<string,string> {
    return getWrapperStyle(this.elementPositionOnCanvas);
  }

  get cssStyleForOutline(): Record<string,string> {
    return getOutlineStyle(this.elementPositionOnCanvas);
  }
}
